import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "voiceSelector"
};
const _hoisted_2 = {
  class: "voiceSelector__filters"
};
const _hoisted_3 = {
  class: "voiceSelector__favToggle"
};
const _hoisted_4 = {
  class: "voiceSelector__favLabel"
};
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  key: 0,
  class: "voiceSelector__advancedHint"
};
const _hoisted_7 = {
  class: "voiceSelector__gridWrap"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "voiceCard__info"
};
const _hoisted_11 = {
  class: "voiceCard__name"
};
const _hoisted_12 = {
  class: "voiceCard__meta"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 0,
  class: "voiceSelector__empty"
};
const _hoisted_15 = {
  class: "voiceSelector__footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_icon = _resolveComponent("icon");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.active,
    width: "800px",
    "custom-class": "voiceSelectorDialog",
    "close-on-outside-click": true,
    "append-to-body": true,
    title: _ctx.$t('aiSpeachGenerator.voiceSelector.title'),
    onOnDialogClose: _ctx.close
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_standard_button, {
      outlined: true,
      onAction: _ctx.close
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.voiceSelector.cancel')), 1)]),
      _: 1
    }, 8, ["onAction"]), _createVNode(_component_standard_button, {
      disabled: !_ctx.selectedVoiceId,
      onAction: _ctx.validate
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.voiceSelector.validate')), 1)]),
      _: 1
    }, 8, ["disabled", "onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!_ctx.gender ? (_openBlock(), _createBlock(_component_el_select, {
      key: 0,
      "model-value": _ctx.genderFilter,
      size: "default",
      class: "voiceSelector__filter",
      onChange: _ctx.onGenderChange
    }, {
      default: _withCtx(() => [_createVNode(_component_el_option, {
        value: "",
        label: _ctx.$t('aiSpeachGenerator.styleStep.filterGenderAll')
      }, null, 8, ["label"]), _createVNode(_component_el_option, {
        value: "MALE",
        label: _ctx.$t('aiSpeachGenerator.styleStep.filterGenderMale')
      }, null, 8, ["label"]), _createVNode(_component_el_option, {
        value: "FEMALE",
        label: _ctx.$t('aiSpeachGenerator.styleStep.filterGenderFemale')
      }, null, 8, ["label"])]),
      _: 1
    }, 8, ["model-value", "onChange"])) : _createCommentVNode("", true), _createVNode(_component_el_select, {
      "model-value": _ctx.useCaseFilter,
      size: "default",
      class: "voiceSelector__filter",
      onChange: _ctx.onUseCaseChange
    }, {
      default: _withCtx(() => [_createVNode(_component_el_option, {
        value: "",
        label: _ctx.$t('aiSpeachGenerator.styleStep.filterUseCaseAll')
      }, null, 8, ["label"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useCaseOptions, uc => {
        return _openBlock(), _createBlock(_component_el_option, {
          key: uc,
          value: uc,
          label: uc
        }, null, 8, ["value", "label"]);
      }), 128))]),
      _: 1
    }, 8, ["model-value", "onChange"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.voiceSelector.favorites')), 1), _createVNode(_component_el_switch, {
      "model-value": _ctx.showFavoritesOnly,
      onChange: _ctx.onFavToggle
    }, null, 8, ["model-value", "onChange"])]), _createElementVNode("button", {
      class: "voiceSelector__clear",
      disabled: !_ctx.hasActiveFilter,
      onClick: _cache[0] || (_cache[0] =
      //@ts-ignore
      (...args) => _ctx.clearFilters && _ctx.clearFilters(...args))
    }, _toDisplayString(_ctx.$t('aiSpeachGenerator.voiceSelector.clearFilters')), 9, _hoisted_5)]), _ctx.advancedTtsEnabled ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_icon, {
      icon: "star-four-points-circle-outline",
      color: "warning"
    }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.voiceSelector.advancedCreditsHint')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_createVNode(_TransitionGroup, {
      name: "voiceCard",
      tag: "div",
      class: "voiceSelector__grid"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredVoices, voice => {
        return _openBlock(), _createElementBlock("div", {
          key: voice.voice,
          class: _normalizeClass(["voiceCard", {
            'voiceCard--selected': voice.voice === _ctx.selectedVoiceId
          }]),
          onClick: $event => _ctx.selectVoice(voice)
        }, [_createElementVNode("button", {
          class: "voiceCard__play",
          onClick: _withModifiers($event => _ctx.previewVoice(voice), ["stop"])
        }, [_createVNode(_component_icon, {
          icon: _ctx.playingVoiceId === voice.voice ? 'stop' : 'play'
        }, null, 8, ["icon"])], 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(voice.label), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.voiceMeta(voice)), 1)]), _createElementVNode("button", {
          class: _normalizeClass(["voiceCard__fav", {
            'voiceCard__fav--active': _ctx.isFavorite(voice.voice)
          }]),
          onClick: _withModifiers($event => _ctx.toggleFavorite(voice.voice), ["stop"])
        }, [_createVNode(_component_icon, {
          icon: _ctx.isFavorite(voice.voice) ? 'star' : 'star-outline'
        }, null, 8, ["icon"])], 10, _hoisted_13)], 10, _hoisted_8);
      }), 128))]),
      _: 1
    }), _ctx.filteredVoices.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('aiSpeachGenerator.voiceSelector.noResult')), 1)) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}